import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { chunk } from '../../../common/utils';
import './styles.scss';
import PropTypes from 'prop-types';

function getOpacity(percent, index) {
    let opacity;
    if (index) {
        if (index < 6) {
            return 1 - index / 10;
        }
        return 0.4;
    }
    switch (true) {
        case percent >= 90:
            opacity = 1.0;
            break;

        case percent >= 80:
            opacity = 0.9;
            break;
        case percent >= 70:
            opacity = 0.8;
            break;
        case percent >= 50:
            opacity = 0.6;
            break;
        case percent >= 20:
            opacity = 0.6;
            break;

        case percent >= 15:
            opacity = 0.5;
            break;

        case percent >= 5:
            opacity = 0.4;
            break;

        default:
            opacity = 0.4;
    }
    return opacity;
}
function ReportChart({
    title,
    type,
    tagData,
    onSelectFilter,
    filter,
    selectedIds,
    onClearFilter,
}) {
    const [showMore, setShowMore] = useState(false);
    if (selectedIds.length)
        tagData = tagData.filter((tg) =>
            tg.tags.some((s) => selectedIds.indexOf(s) > -1),
        );
    const hasMoreItem = tagData.length > 5;

    const CHUNK_SIZE = 10;
    return (
        <>
            <div className="chart-card">
                <div className="d-flex justify-content-between">
                    <h6>{title}</h6>
                    {tagData.length > 0 && (
                        <button
                            disabled={!filter}
                            onClick={() => onClearFilter(type)}
                            className="clearBtn"
                        >
                            Clear
                        </button>
                    )}
                </div>
                <div className="row">
                    <div className="chart category">
                        <div className="chart-segment">
                            {tagData.slice(0, 5).map((c, index) => (
                                <button
                                    key={`segments-${c.id}-${index}`}
                                    className={'chartItem'}
                                    style={{ width: `${c.percent}%` }}
                                    onClick={(e) => {
                                        onSelectFilter(
                                            e.currentTarget.id,
                                            type,
                                        );
                                    }}
                                    id={c.id}
                                    disabled={filter ? filter !== c.id : false}
                                >
                                    <p className="label">
                                        {c.count} ({c.percent}%)
                                    </p>
                                    <p
                                        className={`title ${
                                            c.name ? '' : 'hide'
                                        }`}
                                    >
                                        {c.name ? c.name : 'blank'}
                                    </p>
                                    <span
                                        className={`block ${
                                            filter
                                                ? filter == c.id
                                                    ? 'chartItem-active'
                                                    : ''
                                                : ''
                                        }`}
                                        title={title}
                                        style={{
                                            opacity: getOpacity(
                                                c.percent,
                                                index + 1,
                                            ),
                                            width: '100%',
                                        }}
                                    >
                                        <span
                                            className="value"
                                            data={c.percent}
                                        ></span>
                                    </span>
                                </button>
                            ))}
                            {hasMoreItem ? (
                                <div className="show-more">
                                    <button
                                        type="button"
                                        className={`btn btn-custom ${
                                            showMore
                                                ? 'btn-regular'
                                                : 'btn-reverse'
                                        }`}
                                        aria-controls="show-more-items"
                                        aria-expanded={showMore}
                                        onClick={() =>
                                            setShowMore(
                                                (prevShowMore) => !prevShowMore,
                                            )
                                        }
                                    >
                                        Expand
                                    </button>
                                </div>
                            ) : null}

                            {!tagData.length ? (
                                <label className="no-data">
                                    No Data to Show
                                </label>
                            ) : null}
                        </div>
                        {hasMoreItem ? (
                            <Collapse in={showMore}>
                                <div
                                    id="show-more-items"
                                    className="more-items-segment"
                                >
                                    {chunk(
                                        tagData.slice(5, tagData.length),
                                        CHUNK_SIZE,
                                    ).map((cd, index) => (
                                        <div
                                            className={`chart-segment ${
                                                cd.length < CHUNK_SIZE
                                                    ? 'deactive-flex'
                                                    : ''
                                            }`}
                                            key={`more-segments-${index}`}
                                        >
                                            {cd.map((c) => (
                                                <button
                                                    key={`chart-item-${c.id}`}
                                                    className={`chartItem ${
                                                        cd.length < CHUNK_SIZE
                                                            ? 'deactive-flexgrow'
                                                            : ''
                                                    }`}
                                                    style={{
                                                        width: `${c.percent}%`,
                                                    }}
                                                    onClick={(e) => {
                                                        onSelectFilter(
                                                            e.currentTarget.id,
                                                            type,
                                                        );
                                                    }}
                                                    id={c.id}
                                                    disabled={
                                                        filter
                                                            ? filter !== c.id
                                                            : false
                                                    }
                                                >
                                                    <p className="label">
                                                        {c.count} ({c.percent}%)
                                                    </p>
                                                    <p className="title">
                                                        {c.name}
                                                    </p>
                                                    <span
                                                        className={`block ${
                                                            filter
                                                                ? filter == c.id
                                                                    ? 'chartItem-active'
                                                                    : ''
                                                                : ''
                                                        }`}
                                                        title={title}
                                                        style={{
                                                            opacity: getOpacity(
                                                                c.percent,
                                                            ),
                                                            width: '100%',
                                                        }}
                                                    >
                                                        <span
                                                            className="value"
                                                            data={c.percent}
                                                        ></span>
                                                    </span>
                                                </button>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </Collapse>
                        ) : null}
                    </div>
                </div>
            </div>
        </>
    );
}

ReportChart.propTypes = {
    title: PropTypes.string,
    tagData: PropTypes.array,
    type: PropTypes.string.isRequired,
    onSelectFilter: PropTypes.func,
    filter: PropTypes.string,
    selectedIds: PropTypes.array,
    onClearFilter: PropTypes.func,
};

ReportChart.defaultProps = {
    title: '',
    tagData: [],
    onSelectFilter: () => {},
    selectedIds: [],
    onClearFilter: () => {},
};

export default ReportChart;
